<template>
    <tr>
        <th>
            {{ date.format('dddd Do MMMM') }}
        </th>

        <td>
            <b-checkbox
                v-model="checkboxGroup"
                size="is-medium"
                native-value="blnMorning"
                @input="submit"
            >
                Morning
            </b-checkbox>
        </td>

        <td>
            <b-checkbox
                v-model="checkboxGroup"
                size="is-medium"
                native-value="blnAfternoon"
                @input="submit"
            >
                Afternoon
            </b-checkbox>
        </td>

        <td>
            <b-checkbox
                v-model="checkboxGroup"
                size="is-medium"
                native-value="blnEvening"
                @input="submit"
            >
                Evening
            </b-checkbox>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        dateNumber: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            checkboxGroup: [],
        };
    },

    computed: {
        date: function () {
            return this.$dayjs().add(this.dateNumber, 'day');
        },
    },

    methods: {
        submit() {
            this.$store.dispatch('viewingAvailability/save', {
                date: this.date.format('D MMM YYYY'),
                selection: this.checkboxGroup,
            })
            .catch((error) => {
                if(error.response.data.message) {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: error.response.data.message,
                        position: 'is-bottom',
                        type: 'is-danger'
                    });
                }
            });
        },
    },
};
</script>
